<div class="error_container">
  <div>Icon Goes Here...</div>
  >
  <img class="error_pic" src="../../../../assets/svg/icons/error_page.svg" width="450px" alt="server error" />
  <h2 class="error_message">Oops! It looks like we're having issues. Our team has been notified.'</h2>
  <h2 class="error_number">ERR 500: Server Error</h2>
  <button class="button_main_white" routerLink="/"><mat-icon>home</mat-icon>BACK TO HOME</button>
</div>
